import { Overview } from '@features/ForestOwner/Search/Overview/Overview.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/')({
  component: Overview,
  staticData: {
    breadcrumb: 'Oversikt',
  },
})
